import { createApp } from "vue";
import App from "./App.vue";

// import "bootstrap/dist/css/bootstrap.min.css"
// import "bootstrap"

// import BootstrapVue3 from 'bootstrap-vue-3'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
// import * as Sentry from "@sentry/vue";

const app = createApp(App);

//want to load origin dynacmially to handle onlineleadertraining.ca or clicktolearn.co
// var urlOrigin = window.location.origin;

//production
// app.config.globalProperties.apiBaseUrl = 'https://onlineleadertraining.ca/store/api/'
// app.config.globalProperties.apiBaseUrl = urlOrigin + '/store/api/'

//new production api endpoint
// app.config.globalProperties.apiBaseUrl = urlOrigin + '/store/api/'

//local dev - port can change - https required
// app.config.globalProperties.apiBaseUrl = "https://localhost:44300/store/api/";

//new local api endpoint
app.config.globalProperties.apiKey = "cd4ca6f9-8206-4611-afac-3065b5c7167c";

//new local api endpoint
// app.config.globalProperties.apiBaseUrl = "https://api.clicktolearn.co/store/";
app.config.globalProperties.apiBaseUrl = "https://clicktolearnapi.ca/store/";

//new local api endpoint
// app.config.globalProperties.apiBaseUrl = "https://localhost:7168/store/";

// app.config.globalProperties.currencyFormatter = new Intl.NumberFormat('en-US', {
//     style: 'currency',
//     currency: 'USD',
//     // These options are needed to round to whole numbers if that's what you want.
//     //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
//     //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
// });

// Sentry.init({
//   app,
//   dsn: "https://edd649b5c8929d371da3c60923380211@o513383.ingest.sentry.io/4506769689477120",
//   integrations: [
//     Sentry.browserTracingIntegration(),

//     Sentry.replayIntegration({
//       maskAllText: false,
//       blockAllMedia: false,
//       networkDetailAllowUrls: [
//         window.location.origin,
//         "localhost",
//         "localhost:7168",
//         "api.clicktolearn.co",
//         /^https:\/\/api\.clicktolearn\.co/,
//         "https://localhost:7168/store/Billing/CreateSubscription",
//         "https://api.clicktolearn.ca/store/Billing/CreateSubscription",
//         "https://clicktolearnapi.ca",
//       ],
//       networkRequestHeaders: ["Cache-Control"],
//       networkResponseHeaders: ["Referrer-Policy"],
//     }),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: [
//     "localhost",
//     /^https:\/\/store.clicktolearn.co/,
//     /^https:\/\/store.onlineleadertraining.ca/,
//     /^https:\/\/clicktolearnapi\.ca/,
//   ],
//   // Session Replay
//   replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

// app.use(BootstrapVue3)
app.mount("#app");
